var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Lux"] = 1] = "Lux";
    DeviceType[DeviceType["Exact"] = 2] = "Exact";
    DeviceType[DeviceType["Omni"] = 3] = "Omni";
    DeviceType[DeviceType["OmniPro"] = 4] = "OmniPro";
})(DeviceType || (DeviceType = {}));
export default DeviceType;
